module.exports = __webpack_public_path__ + "media/images/matter_ic-5c121f5296ba4566646f4d225bab602a.svg";